"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitlesWrapper = exports.SuggestedCardWrapper = exports.SuggestedCardBodyWrapper = exports.Subtitle = exports.Logo = exports.FeaturedRibbon = exports.ContentWrapper = exports.ButtonWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var SuggestedCardWrapper = (0, _styledComponents["default"])(_baseReactComponents.StandardCard).withConfig({
  displayName: "SuggestedCardWrapper",
  componentId: "sc-1jzpg74-0"
})(["&&{padding:", ";border:", ";}"], function (_ref) {
  var featuredTitle = _ref.featuredTitle;
  return featuredTitle ? '48px 32px 32px' : '32px;';
}, function (_ref2) {
  var featuredTitle = _ref2.featuredTitle;
  return featuredTitle ? "2px solid ".concat(_baseReactComponents.theme.navBlue) : "1px solid ".concat(_baseReactComponents.theme.scuttleGray200);
});
exports.SuggestedCardWrapper = SuggestedCardWrapper;

var SuggestedCardBodyWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SuggestedCardBodyWrapper",
  componentId: "sc-1jzpg74-1"
})(["text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:space-between;height:100%;"]);

exports.SuggestedCardBodyWrapper = SuggestedCardBodyWrapper;

var Logo = _styledComponents["default"].img.withConfig({
  displayName: "Logo",
  componentId: "sc-1jzpg74-2"
})(["max-width:144px;"]);

exports.Logo = Logo;

var TitlesWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TitlesWrapper",
  componentId: "sc-1jzpg74-3"
})([""]);

exports.TitlesWrapper = TitlesWrapper;

var ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-1jzpg74-4"
})(["display:flex;flex-direction:column;align-items:center;padding-top:16px;"]);

exports.ContentWrapper = ContentWrapper;

var FeaturedRibbon = _styledComponents["default"].div.withConfig({
  displayName: "FeaturedRibbon",
  componentId: "sc-1jzpg74-5"
})(["position:absolute;top:0;left:32px;background-color:", ";border-color:", ";border:17.5px ", " solid;border-top:22.5px ", " solid;border-bottom:12.5px solid ", ";"], _baseReactComponents.theme.navBlue, _baseReactComponents.theme.navBlue, _baseReactComponents.theme.navBlue, _baseReactComponents.theme.navBlue, _baseReactComponents.theme.belugaWhite);

exports.FeaturedRibbon = FeaturedRibbon;
var Subtitle = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "Subtitle",
  componentId: "sc-1jzpg74-6"
})(["margin-top:8px;"]);
exports.Subtitle = Subtitle;

var ButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ButtonWrapper",
  componentId: "sc-1jzpg74-7"
})(["margin-top:8px;"]);

exports.ButtonWrapper = ButtonWrapper;
//# sourceMappingURL=styles.js.map